export const isUnverifiedPasswordUser = (user) => {
  if (!user) return false;
  const providers = user.providerData?.map((provider) => provider.providerId) || [];
  return !user.emailVerified && (providers.includes("password") || providers.length === 0);
};

